import { IResponse } from '../../common/model/Core.model'
import { environment } from '../../util/Environment'
import { apiSlice } from '../store/Api'
import { IReportMetadataDto, IReportMetadataSearchByAreaRequestDto, IReportMetadataSearchRequestDto } from './ReportMetadata.model'

export const reportMetadataApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      reportMetadataSearch: builder.mutation<IResponse, IReportMetadataSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/metadata/search`,
            method: 'POST',
            body,
          }
        },
      }),
      reportMetadataGetByArea: builder.mutation<IResponse, IReportMetadataSearchByAreaRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.report}/metadata/area`,
            method: 'POST',
            body,
          }
        },
      }),
      reportMetadataGetById: builder.mutation<IReportMetadataDto, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.report}/metadata/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
    }
  },
})

export const {
  useReportMetadataSearchMutation,
  useReportMetadataGetByAreaMutation,
  useReportMetadataGetByIdMutation,
} = reportMetadataApi
